export enum NextStep {
  SUMMARY = 'summary',
  DEPOSIT_BUMP = 'deposit_bumping',
  BANK_STATEMENT = 'bank_statement',
  RUN_PRE_APPROVAL = 'run_pre_approval',
  DECLINED_MESSAGE = 'declined_message',
  CANCEL = 'cancel',
  HOUSEHOLD_EXPENSES = 'Household Expenses',
}
